import { render, staticRenderFns } from "./StreamNotStartedYetDialog.vue?vue&type=template&id=15c52c44&scoped=true&"
import script from "./StreamNotStartedYetDialog.vue?vue&type=script&lang=js&"
export * from "./StreamNotStartedYetDialog.vue?vue&type=script&lang=js&"
import style0 from "./StreamNotStartedYetDialog.vue?vue&type=style&index=0&id=15c52c44&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c52c44",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
